import { getTranslateByKey, isShowControlByElementId } from "@/main/services/utils";
import { Controls } from "@/main/services/constants/constantsControl";
import * as S from "./styles";

interface IInfoShippingCostAndTotal {
	total: string;
}
function InfoShippingCostAndTotal({ total }: IInfoShippingCostAndTotal) {
	const showPrices = isShowControlByElementId(Controls.IdShowPrices);

	return (
		<S.Container>
			{showPrices && (
				<S.Total>
					<span>{getTranslateByKey("information.total")}</span>
					{<span>{total}</span>}
				</S.Total>
			)}
		</S.Container>
	);
}
export default InfoShippingCostAndTotal;
